import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute } from "vue-router";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationButton',
  props: {
    to: { type: String, required: true },
},
  setup(__props) {

const props = __props;

const route = useRoute();

const isActive = computed(() => route.path === props.to);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, { to: __props.to }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["hover:bg-white hover:text-black px-3 h-full flex items-center uppercase font-medium", isActive.value ? 'bg-white text-black' : ''])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _: 3
  }, 8, ["to"]))
}
}

})